import {Modal} from "antd";
import React, {useEffect, useState} from "react";
import {BlockOutlined} from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";
import ArtworkCollectionSelect from "../../collection/ArtworkCollectionSelect";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)
    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <BlockOutlined/> In Collection
            </FilterButton>
            <Modal
                title='Collection Filter'
                visible={visible}
                open={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            collectionFilter: {
                                text: 'Collection',
                                value: value
                            },
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <ArtworkCollectionSelect
                    artistId={props.artistId}
                    role={props.role}
                    placeholder='Please select the collection'
                    defaultValue={defaultValue}
                    onChange={setValue}
                />
            </Modal>
        </>
    )
}